// extracted by mini-css-extract-plugin
export default {"section_content":"termsofservice_section_content__iXuJE","pere_content_box":"termsofservice_pere_content_box__mJoPx","pere_content":"termsofservice_pere_content__vn3Jk"};